import { render } from "./BoardTile.vue?vue&type=template&id=62964e76&ts=true"
import script from "./BoardTile.vue?vue&type=script&lang=ts"
export * from "./BoardTile.vue?vue&type=script&lang=ts"

import "./BoardTile.vue?vue&type=style&index=0&id=62964e76&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__